{
  "selected": "Selected: {{count}}",
  "clearSelection": "Clear selection",
  "selectAll": "Select all rows",
  "selectRow": "Select row",
  "actions": "Actions"
}
